import { css } from '@linaria/core';
import Tooltip from '@mui/material/Tooltip';
import { HTMLAttributes, ReactElement } from 'react';
import theme from './theme';

const className = css`
    color: ${theme.color.blue.primary};
    background: none;
    border: none;
    padding: 0;
`;

interface IconButtonProps extends Omit<HTMLAttributes<HTMLButtonElement>, 'className' | 'type'> {
    children: ReactElement;
    label: string;
}

const IconButton = ({ children, label, ...rest }: IconButtonProps) => (
    <Tooltip title={label} placement="top" arrow>
        <button {...rest} aria-label={label} className={className} type="button">
            {children}
        </button>
    </Tooltip>
);

export default IconButton;
